import { noopReducer } from '../noopReducer';

const initialState = {
  description: '',
  h1: 'Сравнение квартир',
  title: 'Сравнение квартир',
};

export const seoDataReducer = noopReducer(initialState);
